'use strict';

import {isEmpty} from '@uw-it-sis/lib-react/lib/Utils';

/**
 * Methods to help with Facet logic.
 */
const FacetUtils = {};

/**
 * Finds a facet id from a string, array, or event.
 */
FacetUtils.findFacetId = function(obj) {
    let facetId = null;

    // From reset events.  There was a check here against the name of the constructor of the object,
    // but constructor and class names are truncated when the JS is minified, so we check for an expected property match
    if (! isEmpty(obj.target) &&
        ! isEmpty(obj.target.id)) {
        let tokens = obj.target.id.split("__");
        facetId = tokens[0];
    } else {
        let filterId = null;
        // From the slider component
        if (obj.constructor === Array) {
            filterId = obj[0];
        } else {
            // From boolean components
            filterId = obj;
        }
        let tokens = filterId.split("__");
        facetId = tokens[0];
    }
    return facetId;
};

/**
 * Digs filter Ids out of an object.
 * @param obj A string (from boolean component) or an array (from the slider or other non-boolean component).
 * @returns {*}
 */
FacetUtils.findFilterIds = function(obj) {
    let facetId = null;
    if (Object.prototype.toString.call(obj) === '[object Array]') {
        return obj;
    } else {
        let filterId = obj.target.id;
        return filterId;
    }
};

export default FacetUtils;